export default "__VITE_ASSET__724efb97__"